import { render, staticRenderFns } from "./LoggingDetail.vue?vue&type=template&id=6e47fd03&"
import script from "./LoggingDetail.vue?vue&type=script&lang=js&"
export * from "./LoggingDetail.vue?vue&type=script&lang=js&"
import style0 from "./LoggingDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports